import { httpClient } from '../http/httpClient'

export interface customerUpdateDataResponse {
  _id: string
  name: string
  email: string
  phone: string
  birthDate: string
  address: {
    zipCode: string
    state: string
    city: string
    neighborhood: string
    street: string
    number: string
  }
  bankAccount: {
    bank: string
    agency: string
    account: string
    accountType: string
    pixKey: string
    pixType: string
  }
}

export interface customerUpdateData {
  _id?: string
  name?: string
  email?: string
  phone?: string
  birthDate?: string
  address?: {
    zipCode?: string
    state?: string
    city?: string
    neighborhood?: string
    street?: string
    number?: string
  }
  bankAccount?: {
    bank?: string
    agency?: string
    account?: string
    accountType?: string
    pixKey?: string
    pixType?: string
  }
}

export async function customerUpdate(
  updateData: customerUpdateData,
  id: string,
) {
  const { data } = await httpClient.put<customerUpdateDataResponse>(
    `/customer/${id}`,
    updateData,
    {
      headers: {
        'x-mock-response-name': 'Update Customer',
      },
    },
  )

  return data
}
